var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReminderIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 22,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M11 4.333A6.67 6.67 0 0 0 4.333 11 6.67 6.67 0 0 0 11 17.666 6.67 6.67 0 0 0 17.666 11 6.67 6.67 0 0 0 11 4.333m.666 10h-1.333v-4h1.333zm0-5.333h-1.333V7.666h1.333z"
})));
export { SvgReminderIcon as ReactComponent };
export default "/_next/static/images/reminder-icon.svg";